import { AbstractControl, FormArray, ValidatorFn } from '@angular/forms';

export const uniqueEmailValidator: (formArray: FormArray) => ValidatorFn = (formArray: FormArray) => {
  return (control: AbstractControl) => {
    const emailInput = control.value;
    if (!emailInput || emailInput === '') {
      return null;
    }
    const emailAddresses = formArray.controls.map((ctrl: AbstractControl) => ctrl.get('emailAddress').value);
    const duplicateEmailExists = emailAddresses.filter((email: string) => email === emailInput).length > 1;

    return duplicateEmailExists ? { uniqueEmailAddresses: true } : null;
  };
};

